import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDragon = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M8.324 4.75a.75.75 0 0 1 .75-.75h7.243c1.137 0 1.936.333 2.463.708.209.148.37.299.49.43.33-.001.64 0 .9.02.357.03.778.107 1.128.394.363.298.522.714.602 1.133.079.414.1.935.1 1.564a.75.75 0 0 1-.75.75h-3.07c-.332 0-.478.09-.549.155-.083.075-.153.198-.197.384a2 2 0 0 0-.033.195h2.71a.75.75 0 1 1 0 1.5H16.76q-.04.009-.099.03a.8.8 0 0 0-.28.163.38.38 0 0 0-.126.248c-.017.13-.001.382.198.803l.001.002q.115.24.264.538c.39.784.914 1.835 1.194 2.945a.75.75 0 1 1-1.454.367c-.236-.935-.66-1.79-1.046-2.566q-.166-.332-.315-.645-.423-.891-.33-1.634a1.88 1.88 0 0 1 .688-1.24c.145-.12.296-.211.434-.28 0-.223.019-.492.085-.771.088-.373.271-.808.65-1.151.392-.355.917-.543 1.555-.543h2.305a4 4 0 0 0-.058-.532c-.033-.174-.069-.238-.081-.256-.015-.008-.085-.04-.299-.057-.212-.018-.468-.017-.822-.016l-.321.001a.755.755 0 0 1-.65-.376l-.004-.005a1.515 1.515 0 0 0-.337-.326c-.275-.196-.77-.432-1.595-.432H9.074a.75.75 0 0 1-.75-.75"
      />
      <path
        fill="currentColor"
        d="M10.742 6.31h3.593a.75.75 0 0 1 0 1.5h-3.593a.75.75 0 1 1 0-1.5M11.785 9.438a.75.75 0 0 1 .75-.75h1.8a.75.75 0 0 1 0 1.5h-1.8a.75.75 0 0 1-.75-.75"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.075 4.226a.75.75 0 0 0-1.195.183l-.003.004-.006.012-.023.045q-.03.057-.083.165a28.643 28.643 0 0 0-1.144 2.663c-.523 1.413-1.056 3.227-1.09 4.877a.75.75 0 0 0 .316 1.461l.378-.049.028.007a4.111 4.111 0 0 1 1.256.577c.629.433 1.306 1.167 1.555 2.44l-.085.079a.75.75 0 1 0 1.018 1.101l.182-.168.048-.013a5.93 5.93 0 0 1 1.791-.158c1.109.075 2.493.492 3.658 1.892a.75.75 0 0 0 1.153-.96c-1.484-1.783-3.29-2.333-4.71-2.428l-.128-.008 2.737-2.53v1.608c0 .7.287 1.514.886 2.05l.039.032.83.648a.75.75 0 0 0 .923-1.182l-.808-.63c-.222-.21-.37-.581-.37-.918v-3.323a.75.75 0 0 0-.219-.53zm4.776 6.909-5.09-5.1a27 27 0 0 0-.733 1.782c-.486 1.313-.918 2.83-.989 4.152l3.554-.462a.75.75 0 0 1 .193 1.487l-2.008.261a5.1 5.1 0 0 1 1.524 2.211l2.983-2.756-.849.097a.75.75 0 1 1-.17-1.49z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDragon;
